import {useLazyQuery} from "@apollo/client";
import {useEffect} from "react";

import {ContactGroupFormResult, GQL_CONTACT_GROUP_FORM} from "@/lib/queries/contacts.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {ContactGroup} from "@/lib/types/contacts.ts";
import {ContactFormValues, EditContactForm} from "@/pages/contacts/components/form/EditContactForm.tsx";

interface EditContactModalProps {
  formId: string;
  title: string;
  defaultValues?: ContactGroup;
  onSubmit: (data: ContactFormValues) => Promise<void>;
  onCancel: () => void;
  show: boolean;
  serverErrors?: ServerErrors;
}

export const EditContactModal = ({
  formId,
  onCancel,
  defaultValues,
  onSubmit,
  show,
  title,
  serverErrors,
}: EditContactModalProps) => {
  const [loadFormData, {data, loading}] = useLazyQuery<ContactGroupFormResult>(GQL_CONTACT_GROUP_FORM);
  useEffect(() => {
    if (show && !data && !loading) {
      loadFormData();
    }
  }, [data, loadFormData, loading, show]);

  return (
    <>
      {!loading && data && show && (
        <EditContactForm
          title={title}
          defaultValues={defaultValues}
          formId={formId}
          onSubmit={onSubmit}
          onCancel={onCancel}
          serverErrors={serverErrors}
          integrationProfiles={data.integrationProfiles}
          pushNotificationProfiles={data.pushNotifications}
        />
      )}
    </>
  );
};
